import React from 'react';
import PropTypes from 'prop-types';

const MoreSidebar = ({ sections, activeSection, onSelect }) => (
  <nav className="vibe-more-sidebar" aria-label="More">
    {sections.map((section) => {
      const active = section.id === activeSection;
      return (
        <button
          key={section.id}
          type="button"
          className={`vibe-more-item${active ? ' is-active' : ''}`}
          aria-current={active ? 'page' : undefined}
          onClick={() => onSelect(section.id)}
        >
          <i className={`wb ${section.icon}`} aria-hidden="true" />
          <span>{section.label}</span>
        </button>
      );
    })}
  </nav>
);

MoreSidebar.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
    }),
  ).isRequired,
  activeSection: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default MoreSidebar;
